export const SLIM = "slim";
export const LONG = "long";
